export function useSpecialOrderLinker() {
  const { createLinkByRouteName } = useLinker();

  const specialOrderLink = createLinkByRouteName(`SpecialOrders`);
  const specialOrderSingleLink = createLinkByRouteName(
    "SpecialOrdersDetailsPage",
  );

  return {
    specialOrderLink,
    specialOrderSingleLink,
  };
}
